var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNetwork(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 36,
    viewBox: "0 0 34 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.0355 31.7149C24.8256 31.7149 22.2141 29.3408 22.2141 26.4226C22.2141 23.5045 24.8256 21.1304 28.0355 21.1304C31.2455 21.1304 33.857 23.5045 33.857 26.4226C33.857 29.3408 31.2455 31.7149 28.0355 31.7149Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.51254 21.1304C5.59439 21.1304 3.22028 18.7563 3.22028 15.8382C3.22028 12.92 5.59439 10.5459 8.51254 10.5459C11.4307 10.5459 13.8048 12.92 13.8048 15.8382C13.8048 18.7563 11.4307 21.1304 8.51254 21.1304Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2538 15.5951L27.3921 21.4437C27.79 22.0419 27.5079 23.186 26.4639 23.9188C25.456 24.626 24.0879 24.2141 23.8908 23.8643L19.6728 17.9618L13.4704 17.9073C12.8839 17.9073 11.6879 17.2274 11.6879 15.7825C11.6879 14.4532 12.8834 13.6098 13.4704 13.6098H19.4337L22.9881 8.00638C23.2819 7.48553 24.845 7.10852 25.6675 7.59831C26.9713 8.37467 26.8889 9.90615 26.5957 10.4275L23.2538 15.5951Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0355 11.6041C23.8255 11.6041 21.214 9.22995 21.214 6.31179C21.214 3.39364 23.8255 1.01953 27.0355 1.01953C30.2454 1.01953 32.857 3.39364 32.857 6.31179C32.857 9.22995 30.2454 11.6041 27.0355 11.6041Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetwork);
export default __webpack_public_path__ + "static/media/network.376e81f71769615d731c9301b44097d7.svg";
export { ForwardRef as ReactComponent };